var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpApiRequest } from "./http-api-request.js";
export function getTemplates(config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpApiRequest(`v5/templates`, config).setMethod('GET').fetch();
        if (response.data == null) {
            return [];
        }
        let templateListPlain = response.data;
        let templatesJson = templateListPlain.items;
        if (templatesJson == null) {
            return [];
        }
        return templatesJson;
    });
}
//# sourceMappingURL=template-service.js.map